import web2clientapi from '@wg/web2clientapi';
import { sendAction } from '@wg/web2clientapi/core/action';
import { shipyardMoveCamera } from '@wg/web2clientapi/shipyard/shipyardMoveCamera';
import { shipyardHideScreenshot } from '@wg/web2clientapi/shipyard/shipyardHideScreenshot';
import { isIngame } from '@wg/web2clientapi/utils/checkIngame';
import { openExternalUrl } from '@wg/web2clientapi/browser/openExternalUrl';
import { updateBrowserControlState } from '@wg/web2clientapi/browser/updateBrowserControlState';
import { updateBrowserOverScrollableState } from '@wg/web2clientapi/browser/updateBrowserOverScrollableState';
import { shipyardSoundOff, shipyardSoundOn } from '@wg/web2clientapi/sound';

// eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-empty-function
const clb = (success?: PromiseLike<undefined>): void => {};

class ClientApi {
    private waitingList: number[] = [];

    isInGame = isIngame;

    openExternalUrl = openExternalUrl;

    hideScreenshot = shipyardHideScreenshot;

    setCameraOnShip = shipyardMoveCamera;

    setScrollover = updateBrowserOverScrollableState;

    setDialogState = updateBrowserControlState;

    addLevelToWaitingList = (level: number) => {
        if (!this.waitingList.includes(level)) {
            this.waitingList.push(level);
        }
    };

    removeLevelFromWaitingList = (level: number) => {
        if (this.waitingList.includes(level)) {
            this.waitingList = this.waitingList.filter((l) => l !== level);
        }
    };

    getWaitingList = () => {
        return this.waitingList;
    };

    clearWaitingList = () => {
        this.waitingList = [];
    };

    switchSoundState = (soundOn: boolean) => {
        if (soundOn) {
            shipyardSoundOn();
        } else {
            shipyardSoundOff();
        }
    };

    switchWorldRendererState = (enabled: boolean) => {
        sendAction({
            actionId: 'switchWorldRendererState',
            enabled,
        });
    };

    updateDockData = (
        from: string,
        state: ClientState,
        revision: number,
        isInstant = false,
        onSuccess = clb,
        onFailure = clb
    ) => {
        this.addLevelToWaitingList(state.shipLevel);
        const result = sendAction({
            actionId: 'updateDockData',
            info: {
                shipLevel: state.shipLevel,
                extraShipLevel: state.secondaryShipLevel,
                thirdShipLevel: state.tertiaryShipLevel,
                isInstant,
                revision,
                force: true,
            },
        });

        if (result) {
            onSuccess();
        } else {
            onFailure();
        }
    };
}

const clientApi = new ClientApi();

declare global {
    interface Window {
        __web2client: typeof web2clientapi,
        __clientApi: typeof clientApi,
    }
}

window.__web2client = web2clientapi;
window.__clientApi = clientApi;

export default clientApi;
